// extracted by mini-css-extract-plugin
export default {"loadingContainer":"LoadingIndicator_loadingContainer__j6cvR","spinner":"LoadingIndicator_spinner__pIp47","spin":"LoadingIndicator_spin__ZiWvr"};